import { type Breakpoint, Button, type ButtonProps, buttonClasses, styled, typographyClasses } from "@mui/material";

export interface ILoadingButtonStyledProps extends ButtonProps {
  breakpoint?: Breakpoint;
}
export const LoadingButtonStyled = styled<React.FC<ILoadingButtonStyledProps>>(Button, {
  shouldForwardProp: (prop) => prop !== "breakpoint",
})(({ theme, breakpoint = "tablet" }) => ({
  minWidth: 40,
  width: 40,
  height: 32,
  [`& .${typographyClasses.root}`]: {
    display: "none",
  },
  [`& .${buttonClasses.startIcon}, & .${buttonClasses.endIcon}`]: {
    margin: 0,
    "& > :nth-of-type(1)": {
      fontSize: 24,
    },
  },
  [theme.breakpoints.up(breakpoint)]: {
    minWidth: "unset",
    width: "unset",
    height: "unset",
    [`& .${buttonClasses.startIcon}`]: {
      marginLeft: theme.spacing(-0.5),
      marginRight: theme.spacing(1),
    },
    [`& .${buttonClasses.endIcon}`]: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(-0.5),
    },
    [`& .${buttonClasses.startIcon}, & .${buttonClasses.endIcon}`]: {
      "& > :nth-of-type(1)": {
        fontSize: 20,
      },
    },
    [`& .${typographyClasses.root}`]: {
      display: "block",
    },
  },
}));
